import React, { Component, createRef } from "react";
// // Editable
import { success, info, error, warning, clear } from "toastr";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from "moment/moment";
import { categoriTypes, cubeList, process } from "../StaticData.js";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addCubes,
  getCubeBelts,
  getCubesWithProcessId,
  getUserApi,
  updateCubes,
  updateFillerStock,
} from "api";
import { type } from "@testing-library/user-event/dist/type";
import { withTranslation } from "react-i18next";
import RaisedButton from "components/Common/RaisedButton";
import RightSidebar from "components/CommonForBoth/RightSidebar";

class ProcessStockAcceptAndReject extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      colVal: 0,
      rowVal: 0,
      isSubmit: false,
      flag: null,
      submitTrue: false,
      addRowThroughBarcode: "",
      machineOperatorId: props?.location?.query ? props?.location?.query?.data.userId : "",
      remarks: props?.location?.query ? props?.location?.query?.data.cubeBelt.remarks : "", 
      usedCylinder: 2,
      beltId: "",
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: 1, data: null },
      category: "",
      processId:
        props?.location?.query?.isEdit == 1
          ? ""
          : props?.location?.query?.data?.cubeBelt.processId,
      stockList: [],
      JangadList: [],
      userList: [],
      cylinder1:
        props.location.query && props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 1;
              }
            )
          : [],
      acceptStockList: props?.location?.query?.data.stockMachineOperatorInWards,
      cylinder2:
        props.location.query && props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 2;
              }
            )
          : [],
      tray: [],
      notEditableRows1:
        props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            )
          : [],
      notEditableRows2:
        props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            )
          : [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }
  setJangadList() {
    this.setState({
      JangadList: this.state.stockList
        .map(x => {
          return { label: x.mainJangadId, value: x.mainJangadId };
        })
        .filter(y => {
          let stockFillerInWardsList = this.state.stockList.filter(
            x => x.mainJangadId == y.value
          )[0].stockFillerInWards;
          let cyclinder1 = this.state.cylinder1.filter(
            a => a.mainJangadId == y.value
          );
          let cyclinder2 = this.state.cylinder2.filter(
            a => a.mainJangadId == y.value
          );
          return stockFillerInWardsList.length ==
            cyclinder1.length + cyclinder2.length
            ? false
            : true;
        }),
    });
  }

  addRow(cylinder, notEditableRows) {
    this.setState({
      [cylinder]: [
        ...this.state[cylinder],
        {
          id: this.state[cylinder].length + 1,
          isNew: true,
          jangadId: "",
          mainJangadId: "",
          dataEntryStockId: "",
          graderStockId: "",
          assignGraderToFillerStockId: "",
          fillerStockId: "",
          stockDataEntryInWardId: "",
          stockGraderInWardId: "",
          assignGraderToFillerInWardId: "",
          stockFillerInWardId: "",
          diamondId: "",
          srNo: 0,
          weight: 0,
          category: "",
          cylinderNo: cylinder == "cylinder1" ? 1 : 2,
        },
      ],
      [notEditableRows]: [
        ...this.state[cylinder].map(x => x.id),
        this.state[cylinder].length + 1,
      ],
    });
  }

  validateTable() {
    for (let i = 0; i < this.state.cylinder1.length; i++) {
      let e = this.state.cylinder1[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  validateTable1() {
    for (let i = 0; i < this.state.cylinder2.length; i++) {
      let e = this.state.cylinder2[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  async componentDidMount() {
    let factoryId = JSON.parse(localStorage.getItem("authUser")).factoryId;
    this.validateTable();
    this.validateTable1();
    const machineOperator = await getUserApi({
      factoryId: factoryId ? factoryId : null,
      roleId: "ROLE0000004",
    });
    this.setState({
      userList: machineOperator.data.users,
    });
    if (this.state.props.isEdit == 2) {
      let processId = this.state.props.data.processId;
      let cubeBeltId = this.state.props.data.id;
      const data = await getCubesWithProcessId({
        id: processId,
        cubeBeltId: cubeBeltId,
      fillerId : null
      });
      this.setState(
        {
          stockList: data.data.fillerStocks,
        },
        () => {
          this.setState(
            {
              JangadList: this.state.stockList.map(x => {
                return { label: x.mainJangadId, value: x.mainJangadId };
              }),
            },
            () => {
              this.setJangadList();
            }
          );
        }
      );
    }
    // const s = await this.getStockList();
  }

  // async addRowThroughBarcodeF(data) {
  //   // if (data.includes("$")) {
  //   //   let jangadData = data.split("-")[1].split("&");

  //   //   let jangadData1 = jangadData[1].split("$");
  //   //   let jangadId = jangadData[0];

  //   //   let srNo = jangadData1[0];
  //   //   console.log(jangadId);
  //   //   console.log(srNo);
  //   //   let barCodeData = this.state.cylinder1.filter(
  //   //     x => parseInt(x.mainJangadId.split("JANGAD")[1]) == parseInt(jangadId)
  //   //   );
  //   //   console.log(barCodeData);
  //   //   if (barCodeData.length > 0) {
  //   //     let srNoMatch = barCodeData.filter(x => {
  //   //       return x.stockDataEntryInWard.srNo == parseInt(srNo);
  //   //     });
  //   //     console.log(srNoMatch);
  //   //     let temp = {
  //   //       mainJangadId: srNoMatch.mainJangadId,
  //   //       jangadId: srNoMatch.jangadId,
  //   //       assignGraderToFillerStockId:
  //   //         srNoMatch.assignGraderToFillerInWard.assignGraderToFillerStockId,
  //   //       assignGraderToFillerInWardId:
  //   //         srNoMatch.assignGraderToFillerInWard.assignGraderToFillerInWardId,
  //   //       cubeInformationId: srNoMatch.cubeInformationId,
  //   //       dataEntryStockId: srNoMatch.assignGraderToFillerInWard.dataEntryStockId,
  //   //       fillerStockId: srNoMatch.assignGraderToFillerInWard.fillerStockId,
  //   //       graderStockId: srNoMatch.assignGraderToFillerInWard.graderStockId,
  //   //       machineOperatorStockId: srNoMatch.assignGraderToFillerInWard.machineOperatorStockId,
  //   //       stockDataEntryInWardId: srNoMatch.stockDataEntryInWardId,
  //   //       stockFillerInWardId: srNoMatch.stockFillerInWardId,
  //   //       stockGraderInWardId: srNoMatch.stockGraderInWardId,
  //   //       cubeBeltId: srNoMatch.cubeBeltId,
  //   //       stockMachineOperatorInWardId: srNoMatch.id,
  //   //       outWardWeight: values.outWardWeight,
  //   //       outWardPieces: values.outWardPieces,
  //   //       oColorId:
  //   //         this.state.oColorId == "" ? values.iColorId : this.state.oColorId,
  //   //       inclusionId: this.state.selectedMulti.map(y => y.value),
  //   //     };

  //   //     const data = await acceptGraderDiamonds(temp);
  //   //   }
  //   // }
  // }

  async resetValue() {
    this.setState({
      cylinder1: [],
      cylinder2: [],
      isSubmit: false,
      submitTrue: false,
      machineOperatorId: "",
      remarks: "",
      usedCylinder: 2,
      beltId: "",
      processId: "",
    });
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let payload = {
        usedCylinder: values.usedCylinder,
        processId: values.processId,
        ...values,
        cubeInformations: [
          ...this.state.cylinder1.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 1,
            };
          }),
          ...this.state.cylinder2.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 2,
            };
          }),
        ],
      };
      const data = await addCubes(payload);
      this.setState({
        usedCylinder: values.usedCylinder,
        beltId: data.data.cubeId,
      });

      if (data.success == true) {
        this.setState({
          submitTrue: true,
        });
      }
    } else {
      let payload = {
        usedCylinder: values.usedCylinder,
        processId: values.processId,
        ...values,
        cubeInformations: [
          ...this.state.cylinder1.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 1,
            };
          }),
          ...this.state.cylinder2.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 2,
            };
          }),
        ],
      };
      const data = await updateCubes({
        id: payload.cubeInformations[0].cubeBeltId,
        data: payload,
      });
    }
  }

  async acceptStock() {}

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }
  render() {
    document.title = "filler flow";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        editable: false,
        editor: {
          type: Type.SELECT,
          options: this.state.JangadList,
        },
        formatter: (cell, row) => {
   
          if (cell && this.state.stockList.length) {
            row.category = this.state.stockList.filter(
              x => x.mainJangadId == row.mainJangadId
            )[0].mainJangad.category.name;
          }
          if (cell == "") {
            return "NONE";
          } else {
            return row.mainJangad.name + "-" + row.stockDataEntryInWard.srNo;
          }
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        editable: false,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        editable: false,
        formatter: (cell, row) => {
          return row.mainJangad.category.name;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        editable: false,
        formatter: (cell, row) => {
          return row.assignGraderToFillerInWard.weight;
        },
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        editable: false,
        formatter: (cell, row) => {
          return (
            <div className="btn-group">
              <RaisedButton
                name={"View"}
                className={"border-0 p-2 btn-active raised-btn rounded me-2"}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/grader-reassign",
                    state: {
                      previousData: this.state.props.data,
                      data: row,
                      isEdit: 3,
                    },
                  });
                }}
              />
              {row.graderStatus == "P" && (
                <>
                  <RaisedButton
                    name={"Accept"}
                    className={
                      "border-0 p-2 btn-active raised-btn rounded me-2"
                    }
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/grader-reassign",
                        state: {
                          previousData: this.state.props.data,
                          data: row,
                          isEdit: 1,
                        },
                      });
                    }}
                  />
                  <RaisedButton
                    name={"Reassign"}
                    className={
                      "border-0 p-2 btn-active raised-btn rounded me-2"
                    }
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/grader-reassign",
                        state: {
                          previousData: this.state.props.data,
                          data: row,
                          isReject: 1,
                        },
                      });
                    }}
                  />
                </>
              )}
            </div>
          );
        },
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        editor: {
          type: Type.SELECT,
          options: this.state.JangadList,
        },
        formatter: (cell, row) => {
          if (cell && this.state.stockList.length) {
            row.category = this.state.stockList.filter(
              x => x.mainJangadId == row.mainJangadId
            )[0].mainJangad.category.name;
          }
          if (cell == "") {
            return "NONE";
          } else {
            return cell;
          }
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        editable: false,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        editable: false,
        formatter: (cell, row) => {
          return row.mainJangad.category.name;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        editable: false,
        formatter: (cell, row) => {
          return row.assignGraderToFillerInWard.weight;
        },
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        editable: true,
        formatter: (cell, row) => {
          return (
            <div className="btn-group">
              <RaisedButton
                name={"View"}
                className={"border-0 p-2 btn-active raised-btn rounded me-2"}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/grader-reassign",
                    state: {
                      previousData: this.state.props.data,
                      data: row,
                      isEdit: 3,
                    },
                  });
                }}
              />
              {row.graderStatus == "P" && (
                <>
                  <RaisedButton
                    name={"Accept"}
                    className={
                      "border-0 p-2 btn-active raised-btn rounded me-2"
                    }
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/grader-reassign",
                        state: {
                          previousData: this.state.props.data,
                          data: row,
                          isEdit: 1,
                        },
                      });
                    }}
                  />
                  <RaisedButton
                    name={"Reassign"}
                    className={
                      "border-0 p-2 btn-active raised-btn rounded me-2"
                    }
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/grader-reassign",
                        state: {
                          previousData: this.state.props.data,
                          data: row,
                          isReject: 1,
                        },
                      });
                    }}
                  />
                </>
              )}
            </div>
          );
        },
      },
    ];

    document.title = "add party";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("Edit Filling Process (Belt)")}`}
            />
            <Formik
              enableReinitialize={true}
              initialValues={
                this.state.props.isEdit == 1
                  ? {
                      beltId: (this.state && this.state.beltId) || "",
                      processId: (this.state && this.state.processId) || "",
                      usedCylinder:
                        (this.state && this.state.usedCylinder) || "",
                      machineOperatorId:
                        (this.state && this.state.machineOperatorId) || "",
                      remarks: (this.state && this.state.remarks) || "",
                    }
                  : {
                      beltId: this.state.props.data.cubeBelt.cubeId,
                      processId: this.state.props.data.cubeBelt.processId,
                      usedCylinder: this.state.props.data.cubeBelt.usedCylinder,
                      machineOperatorId:
                        this.state.props.data.cubeBelt.machineOperatorId,
                      remarks: this.state.props.data.cubeBelt.remarks,
                    }
              }
              validationSchema={Yup.object().shape({
                beltId: Yup.string().notRequired(),
                processId: Yup.string().required("This Value is Required"),
                usedCylinder: Yup.string().required("This Value is Required"),
                machineOperatorId: Yup.string().nullable().notRequired(),
                remarks: Yup.string().max(512).notRequired(),
              })}
            >
              {({ errors, status, touched, isValid, values, validateForm }) => (
                <Form className="needs-validation">
                  <Card className="px-4">
                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("Edit Filling Process (Belt)")}
                        </h4>
                      </div>
                      {/* <div className="mb-3 row ">
                        <label
                          htmlFor="date"
                          className="col-12 col-sm-2 col-lg-4"
                        >
                          <h5 className="fs-5 fw-bold text-black">Date:</h5>
                        </label>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <input
                            className="border-0 fs-5"
                            type="date"
                            name="date"
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="beltId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Belt Id")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.beltId && touched.beltId
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={true}
                          name="beltId"
                          type="text"
                          placeholder="Enter Belt Id"
                        />
                        <ErrorMessage
                          name="beltId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="processId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Assign Process")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.processId && touched.processId
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.processId}
                          onChange={e => {
                            this.setState(
                              {
                                cylinder1: [],
                                cylinder2: [],
                                notEditableRows1: [],
                                notEditableRows2: [],
                                JangadList: [],
                                stockList: [],
                                processId: e.target.value,
                              },
                              () => this.getCube()
                            );
                          }}
                          disabled={true}
                          name="processId"
                          as="select"
                          defaultValue=""
                        >
                          {process?.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.label}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="processId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="machineOperatorId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                        {this.props.t("Machine Operator")}
                        </h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.machineOperatorId &&
                            touched.machineOperatorId
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.machineOperatorId}
                          onChange={e => {
                            this.setState({
                              machineOperatorId: e.target.value,
                            });
                          }}
                          name="machineOperatorId"
                          as="select"
                          disabled={true}
                        >
                          <option value="" disabled>
                            select
                          </option>
                          {this.state.userList.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="machineOperatorId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="remarks"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Filler Notes")}
                        </h5>
                      </Label>
                      <div className="col-md-10">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.remarks && touched.remarks
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.remarks}
                          onChange={e => {
                            this.setState({
                              remarks: e.target.value,
                            });
                          }}
                          type="text"
                          name="remarks"
                          as="textarea"
                          rows="5"
                          placeholder="Please Take of HPHT First Priority"
                          disabled={true}
                        />
                        <ErrorMessage
                          name="remarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>

                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          <span className="d-inline">
                            {" "}
                            {this.props.t("Belt Details")}
                          </span>
                          {/* <Field
                            type="text"
                            className="form-control d-inline fs-5"
                            value={this.state.addRowThroughBarcode}
                            onChange={e =>
                              this.setState(
                                { addRowThroughBarcode: e.target.value },
                                () =>
                                  this.addRowThroughBarcodeF(
                                    this.state.addRowThroughBarcode
                                  )
                              )
                            }
                          ></Field> */}
                        </h4>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-5 col-lg-6">
                          <Label
                            htmlFor="usedCylinder"
                            className="col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Total Used Cylinder Kit")}
                            </h5>
                          </Label>
                        </div>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.usedCylinder && touched.usedCylinder
                                ? " is-invalid"
                                : "")
                            }
                            disabled={
                              this.state.props.isEdit == 3 ? true : false
                            }
                            name="usedCylinder"
                            type="text"
                            placeholder="Enter Belt Id"
                          ></Field>
                          <ErrorMessage
                            name="usedCylinder"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between pt-5">
                      <h3 className="fw-bold pb-3 text-black">
                        {this.props.t("First Cylinder Kit")}
                      </h3>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField="id"
                        classes="foo"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        data={this.state.cylinder1}
                        columns={this.columns1}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          // nonEditableRows: () => this.state.notEditableRows1,
                          afterSaveCell:() => {
                                  this.setState({
                                    cylinder1: [...this.state.cylinder1]
                                  })
                                }
                        })}
                      />
                    </div>
                    {/* <div className="d-flex justify-content-between pt-5">
                      <h3 className="fw-bold pb-3 text-black">
                        {this.props.t("Second Cylinder Kit")}
                      </h3>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField="id"
                        classes="foo"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        data={this.state.cylinder2}
                        columns={
                          this.state.props.isEdit == 3
                            ? [...this.columns2.slice(0, -1)]
                            : this.columns2
                        }
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          nonEditableRows: () => this.state.notEditableRows2,
                        })}
                      />
                    </div> */}

                    <div className="col-md-12 text-center text-md-end my-4 pe-lg-3">
                      {this.state.props.isEdit == 1 && (
                        <>
                          {/* <Button
                            color="white"
                            className="fs-4 border-0 text-primary me-0 me-md-5 fw-bold"
                            type="submit"
                            onClick={async () => {
                              await validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log("err =>", err));
                            }}
                          >
                            Accept
                          </Button> */}
                          <Button
                            color="primary"
                            onClick={() => this.reject(event, values)}
                            className="fs-4 px-5"
                          >
                            Reject
                          </Button>
                        </>
                      )}
                      {this.state.props.isEdit == 2 && (
                        <>
                          <Button
                            color="primary"
                            className="fs-4 px-5 me-2"
                            onClick={() => {
                              this.props.history.push(
                                "/grader-processed-stock-list"
                              );
                            }}
                          >
                            Back
                          </Button>
                          {/* <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={async () => {
                              await validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log("err =>", err));
                            }}
                          >
                            Assign
                          </Button> */}
                        </>
                      )}
                      {this.state.props.isEdit == 3 && (
                        <Link to="/filler-dashboard">
                          <Button color="primary" className="fs-4 px-5">
                            Back
                          </Button>
                        </Link>
                      )}
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(ProcessStockAcceptAndReject);
